/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SideNavDefault } from './side-nav-default.story';
export { default as SideNavCompact } from './side-nav-compact.story';
export { default as SideNavSecondary } from './side-nav-secondary.story';
export { default as SideNavBadges } from './side-nav-badges.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SideNavBadgesSrcRaw from './side-nav-badges.story?raw';
import SideNavCompactSrcRaw from './side-nav-compact.story?raw';
import SideNavDefaultSrcRaw from './side-nav-default.story?raw';
import SideNavSecondarySrcRaw from './side-nav-secondary.story?raw';

export const SideNavDefaultSrc = removeLicenseHeader(SideNavDefaultSrcRaw);

export const SideNavCompactSrc = removeLicenseHeader(SideNavCompactSrcRaw);

export const SideNavSecondarySrc = removeLicenseHeader(SideNavSecondarySrcRaw);

export const SideNavBadgesSrc = removeLicenseHeader(SideNavBadgesSrcRaw);
